import { KeyValueStorage } from '@vi-iot/client';

export interface BackendStorageState {
  keys: KeyValueStorage[];
  loading: boolean;
  loaded: boolean;
}

export enum storageSessionsKeys {
  ADVERT_BANNER_KEY = 'AdvertCampagneBannerUserVisibility',
}
